import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import Theme from "@app/component/src/theme/Theme";

ReactDOM.render(
  //<React.StrictMode>
  <Theme>
    <Router>
      <Routes />
    </Router>
  </Theme>,
  //</React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
